
import { Vue, Component, Prop } from 'vue-property-decorator';
import Model from './model';

import MenuComponents from '@/components/menu.vue';
// import PageComponents from '@/components/page.vue';



// 必须使用@Component注解
@Component({
  components: {
    MenuComponents,
  },
})
// 必须使用@Component注解
@Component
export default class personAttr extends Vue {
  private model = new Model();
  private data: any = '';

  private question: string = '';
  // 猜出来人物
  private realPersonName: string = '';




  private pageBean = {
    current: 1,
    size: 1,
    pages: 0, // 总页数
    total: 0, // 总记录条数
  };

  private pageParam = {
    pageBean: this.pageBean
  };

  // 页面打开就调用该方法
  private async mounted() {
    this.selectPageData();
  }

  // 查询
  private async selectPageData() {
    const result = await this.model.selectPageData(this.pageParam);
    if (result != null) {
      if ( result.data !=null ) {
        // Vue.prototype.$message.error(result.data.records[0]);
        this.question = result.data.records[0].question;
      }
      
    }
  }
  
  // 查猜出来的人
  private async selectRealPerson() {
    
  }

  private async updateAnswers(val :number) {
    let param = {
      question : this.question,
      questionVal : val
    }
    await this.model.updateAnswer(param);
    this.pageBean.current++;


    // 查询系统猜出来的人物
    const result = await this.model.selectRealPerson(null);
    console.log(result.data);
    if (result != null) {
      debugger;
      if (result.code=="300" ) {
        Vue.prototype.$message.success('猜不出来');
      } else {
        if (result.data!=null) {
          for(let item in result.data) {
            const personName = result.data[item][0].personName;
            let msg = '是' + personName + '吗';

            if(confirm(msg)){
            // let flag = await Vue.prototype.$confirm(msg);
            // if(flag){
              Vue.prototype.$message.success('本轮游戏结束了');
              this.pageBean.current = 1;
              this.deleteCurIp();
              this.selectPageData();
              return ;
            }
          }

          // alert('猜不出来');
          Vue.prototype.$message.success('呜呜呜~ 宝宝猜不出来');
          // this.realPersonName = result.data[0].personId;
          return ;
        }
      }
    }

    this.selectPageData();
  } 

  private async yes() {
    const result = await this.updateAnswers(1);
  }

  private async no() {
    const result = await this.updateAnswers(2);
  }

  private async noKnonw() {
    const result = await this.updateAnswers(3);
  }

  // 清除当前ip的所有问题
  private async deleteCurIp() {
    const result = await this.model.deleteCurIp(null);
    this.pageBean.current = 1;
    this.selectPageData();
  }
  

  
}
